import React from 'react';
import { faPaw } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EventContentArg } from '@fullcalendar/core';
import { createStyles, makeStyles } from '@material-ui/core';
import { faClock } from '@fortawesome/pro-regular-svg-icons';
import ScheduleTypeTotalBadge from 'components/Marketplace/BusinessSettings/ScheduleType/ScheduleTypeCalendar/ScheduleTypeTotalBadge';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            margin: 5,
            fontSize: 12,
            color: '#000',
            fontWeight: 500,
            borderRadius: 4,
            padding: '2px 3px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: '#EFEFEF'
        },
        petsCountBadge: {
            gap: 2,
            fontSize: 11,
            lineHeight: 1,
            fontWeight: 600,
            color: '#ffffff',
            borderRadius: 3.5,
            padding: '4.5px 5px',
            display: 'inline-flex',
            alignItems: 'center',
            backgroundColor: '#000000'
        }
    })
);

export const ScheduleTypeCalendarEvent: React.FC<EventContentArg> = props => {
    const classes = useStyles();

    if (props.event.extendedProps.custom) {
        return <ScheduleTypeTotalBadge {...props} />;
    }

    return (
        <div
            className={classes.root}
            id={`slot-${props.event.id}`}
        >
            <span>
                <FontAwesomeIcon icon={faClock} /> {props.event.extendedProps.from.format('h:mm A')}
            </span>

            <span className={classes.petsCountBadge}>
                <FontAwesomeIcon icon={faPaw} />
                {props.event.extendedProps.petsCount}
            </span>
        </div>
    );
};
